// ════════════════════════════════════════════════════════════════════
// PatientPaperworkHub
// Unified workspace for everything paper-related a patient signs or
// the provider documents:
//   • Consents             — existing ConsentsManager
//   • Pre / Post Care      — existing TreatmentMessagesManager
//   • Questionnaires       — existing FormTemplatesManager
//   • Clinical Notes (NEW) — NoteTemplatesManager (inserted into EMR)
// Replaces 3 separate sidebar entries with one hub.
// ════════════════════════════════════════════════════════════════════
import { useState } from "react";
import { ConsentsManager } from "./ConsentsManager";
import TreatmentMessagesManager from "./TreatmentMessagesManager";
import FormTemplatesManager from "./FormTemplatesManager";
import NoteTemplatesManager from "./NoteTemplatesManager";

const C = {
  bg: "#f8f5f0", surface: "#ffffff", border: "#e8e4df",
  borderGold: "rgba(180,140,60,0.3)", goldBg: "rgba(180,140,60,0.08)",
  gold: "#b48c3c", goldD: "#8a6f2e",
  text: "#1a1a2e", muted: "#6b7280",
};
const F = "'Montserrat',sans-serif";
const S = "'Playfair Display','Cormorant Garamond',Georgia,serif";

const TABS = [
  { id: "consents", label: "📋 Consents",     desc: "What patients sign before treatment" },
  { id: "prepost",  label: "💧 Pre / Post",   desc: "Reminders sent before & after visits" },
  { id: "forms",    label: "📝 Questionnaires", desc: "Intake & health questionnaires" },
  { id: "notes",    label: "📄 Clinical Notes", desc: "Templates staff insert into EMR" },
];

export default function PatientPaperworkHub() {
  const [tab, setTab] = useState("consents");

  return (
    <div style={{display: "flex", flexDirection: "column", gap: 18}}>
      <div>
        <div style={{fontSize: 22, fontWeight: 800, color: C.text, fontFamily: S, marginBottom: 4}}>📁 Patient Paperwork</div>
        <div style={{fontSize: 12, color: C.muted}}>Everything patient-facing or staff-documenting lives here — consents, pre/post messages, questionnaires, and clinical note templates.</div>
      </div>

      <div style={{display: "flex", gap: 6, borderBottom: "1px solid " + C.border, overflowX: "auto", paddingBottom: 1}}>
        {TABS.map(t => {
          const active = tab === t.id;
          return (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{
                padding: "10px 18px",
                background: active ? C.surface : "transparent",
                color: active ? C.goldD : C.muted,
                border: "1px solid " + (active ? C.borderGold : "transparent"),
                borderBottom: active ? "1px solid " + C.surface : "1px solid transparent",
                borderRadius: "8px 8px 0 0",
                fontSize: 13, fontWeight: active ? 800 : 600,
                cursor: "pointer", fontFamily: F,
                marginBottom: -1, whiteSpace: "nowrap",
              }}>
              {t.label}
            </button>
          );
        })}
      </div>

      <div style={{background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 20, minHeight: 400}}>
        {tab === "consents" && <ConsentsManager/>}
        {tab === "prepost"  && <TreatmentMessagesManager/>}
        {tab === "forms"    && <FormTemplatesManager/>}
        {tab === "notes"    && <NoteTemplatesManager/>}
      </div>
    </div>
  );
}
